<template>
  <HeadingLv1 text="登録情報の確認・変更" />

  <div class="u-containar">
    <MypageContents :key="userInfo.ver">
      <router-view
        :userInfo="userInfo"
        :formattedUserInfo="formattedUserInfo"
        @update-user-info="updateUserInfo"
        @update-edit-info="updateEditInfo"
      ></router-view>
    </MypageContents>
  </div>
</template>

<script lang="ts">
import { reactive, defineComponent } from 'vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import { useStore } from 'vuex'
import { axiosSetting } from '@/utils/axiosSetting'

export default defineComponent({
  name: 'MyPageUserProfile',

  components: {
    HeadingLv1,
    MypageContents
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  beforeRouteEnter: async (to: any, from: any) => {
    const getUserInfo = axiosSetting('app', 'page')

    const data = await getUserInfo
      .get('/api/v1/userInfo?is_all=1')
      .then((res) => {
        // hpcr_regist_statusの変換処理
        if (typeof res.data.hpcr_regist_status === 'string') {
          res.data.hpcr_regist_status = Number(res.data.hpcr_regist_status)
            ? true
            : false
        }
        // マイナビDOCTORの変換
        res.data.doctor_regist_flg = !!res.data.doctor_regist_flg
        // vacation_flgのnull対策
        res.data.vacation_flg = res.data.vacation_flg ? true : false

        return res.data
      })

    to.matched[0].props.default = {
      data: data
    }
  },

  setup(props: any) {
    const store = useStore()
    let userInfo = reactive<any>({})
    let formattedUserInfo = reactive<any>({})

    // 初期データ
    userInfo = Object.assign({ ver: 1 }, props.data)
    const formatUserInfo = () => {
      const obj = JSON.parse(JSON.stringify(userInfo))

      obj.main_email_flg = obj.main_email_flg == 1 ? '1' : '2'

      store.state.master.memberType.forEach((el: any) => {
        if (obj.member_type === el.option_name) obj.member_type = el.opt_id
      })
      store.state.master.gender.forEach((el: any) => {
        if (obj.gender === el.option_name) obj.gender = el.opt_id
      })

      formattedUserInfo = obj
    }
    formatUserInfo()

    const updateUserInfo = (data: any) => {
      Object.keys(data).forEach((key: string) => {
        userInfo[key] = data[key]
      })
      userInfo['ver']++
    }

    const updateEditInfo = (params: Record<string, any>) => {
      Object.keys(params).forEach((key: string) => {
        formattedUserInfo[key] = params[key]
      })
    }

    return {
      userInfo,
      formattedUserInfo,
      updateUserInfo,
      updateEditInfo
    }
  }
})
</script>

<style lang="scss" scoped></style>
